document.addEventListener("DOMContentLoaded", () => {
  const navItems = Array.from(document.querySelectorAll(".office-nav-item"));
  const desktopHover = window.matchMedia("(min-width: 1024px)");
  const closeTimers = new Map();

  if (navItems.length === 0) return;

  const cancelScheduledClose = (item) => {
    const timer = closeTimers.get(item);

    if (!timer) return;

    window.clearTimeout(timer);
    closeTimers.delete(item);
  };

  const setOpen = (item, open) => {
    cancelScheduledClose(item);
    item.classList.toggle("is-active", open);
    item.querySelector("[data-office-nav-toggle]")?.setAttribute("aria-expanded", open.toString());
  };

  const closeAll = (except = null) => {
    navItems.forEach((item) => {
      if (item !== except) setOpen(item, false);
    });
  };

  const scheduleClose = (item) => {
    cancelScheduledClose(item);
    closeTimers.set(item, window.setTimeout(() => setOpen(item, false), 140));
  };

  navItems.forEach((item) => {
    const toggle = item.querySelector("[data-office-nav-toggle]");

    if (!toggle) return;

    const toggleItem = () => {
      const opening = !item.classList.contains("is-active");
      closeAll(item);
      setOpen(item, opening);
    };

    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (desktopHover.matches) {
        closeAll(item);
        setOpen(item, true);
        toggle.blur();
        return;
      }

      toggleItem();
    });

    toggle.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();
      toggleItem();
    });

    item.addEventListener("mouseenter", () => {
      if (!desktopHover.matches) return;

      closeAll(item);
      setOpen(item, true);
    });

    item.addEventListener("mouseleave", () => {
      if (desktopHover.matches) scheduleClose(item);
    });

    item.addEventListener("focusin", () => {
      if (!desktopHover.matches) return;

      closeAll(item);
      setOpen(item, true);
    });

    item.addEventListener("focusout", () => {
      if (!desktopHover.matches) return;

      window.requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) setOpen(item, false);
      });
    });
  });

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".office-nav-item")) closeAll();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAll();
  });

  desktopHover.addEventListener("change", () => closeAll());
});
